export const OltActionBtn = ({ icon: Icon, label, onClick, color }) => (
    <button
      type="button"
      onClick={onClick}
      className={`w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-200 cursor-pointer ${color === "#f87171" ? "hover:bg-red-500/15 active:scale-90" : "hover:opacity-80"}`}
      style={{ background: `${color}15`, border: `1px solid ${color}25` }}
      aria-label={label}
    >
      <Icon className="text-sm" style={{ color }} />
    </button>
  );
  